import React from 'react'
import { StyledInputSearch, StyledInputField } from './styled'

const InputSearch = () => (
  <StyledInputSearch>
    <StyledInputField />
  </StyledInputSearch>
)

InputSearch.propTypes = {}

export default InputSearch
